import { useRecoilState } from 'recoil';
import { useEffect } from 'react';
import { popupsAtom } from '../atoms/Popup';
import { getPopups } from '../api/Popup';

export const usePopups = () => {
  const [popups, setPopups] = useRecoilState(popupsAtom);

  useEffect(() => {
    if (!popups) {
      getPopups()
        .then(setPopups)
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        });
    }
  }, []);

  return popups ?? [];
};
